module.exports = __webpack_public_path__ + "870dc20e5ba4e30fc4359ca99266e742.svg";